import axios from "axios";

export default {
  namespaced: true,

  state: () => ({
    user: null
  }),

  mutations: {
    setUser(state, user) {
      state.user = user;
      if (user == null) {
        localStorage.setItem("user", null);
      } else {
        localStorage.setItem("user", JSON.stringify(user));
      }
    }
  },

  actions: {
    async login({ commit }, param) {
      param.device_name = "Website";
      return axios
        .post("/student/login", param)
        .then(async response => {
          const token = response.data.token || null;
          localStorage.setItem("token", token);
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;
          commit("setUser", response.data.user);
          commit(
            "showAlert",
            { message: "Logged in", status: "success" },
            { root: true }
          );
          return response;
        })
        .catch(error => {
          commit(
            "showAlert",
            {
              message: error.response.data.message || "Could not Login",
              status: "danger"
            },
            { root: true }
          );
          throw error;
        });
    },

    async logout({ commit }) {
      return axios.post("/student/logout").then(() => {
        localStorage.setItem("token", null);
        commit("setUser", null);
        commit(
          "showAlert",
          {
            message: "Logged out successfully",
            status: "success"
          },
          { root: true }
        );
        window.location.href = "/login";
      });
    },

    async getUser({ commit }) {
      return axios
        .get("/student")
        .then(response => {
          commit("setUser", response.data);
          return response;
        })
        .catch(error => {
          commit(
            "showAlert",
            {
              message: error.response.data.message || "Could not load user",
              status: "danger"
            },
            { root: true }
          );
          throw error;
        });
    },

    async getUserDetails({ commit }) {
      return axios
        .get("/students")
        .then(response => {
          // student data
          commit("student/courses", response.data.courses, { root: true });
          commit("student/combination", response.data.combination, {
            root: true
          });
          commit("student/subscriptions", response.data.subscriptions, {
            root: true
          });
          return response;
        })
        .catch(error => {
          throw error;
        });
    }

    // register(){}
    // sendPasswordEmail() {},
    // resetPasword() {}
  },

  getters: {},

  modules: {}
};
